var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{ref:"refInput",attrs:{"pattern":"[0-9]*","inputmode":"numeric"},on:{"input":_vm.onInput,"blur":_vm.onInputBlur}})}
var staticRenderFns = []

export { render, staticRenderFns }